import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdMenu } from 'react-icons/io';
import { FiFileText, FiLogOut, FiUser, FiGrid, FiCreditCard } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import './TopNav.css';

const TopNav = ({
  onMenuClick,
  onEvaluateClick,
  onToggleAnketa,
  onNextPhase,
  selectedCase,
  sessionActive,
  sessionId,
  currentPhase,
  currentPhaseIndex,
  totalPhases,
  timer,
  phaseTimeRemaining,
  showLabReports,
  onToggleLabReports,
  onReturnToDashboard,
  onSubscriptionClick,
  showMenuButton = true
}) => {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm(t('logoutConfirm'))) {
      logout();
      navigate('/login');
    }
  };

  return (
    <nav className="top-nav">
      <div className="nav-left">
        {showMenuButton && (
          <button className="menu-btn" onClick={onMenuClick}>
            <IoMdMenu size={24} />
          </button>
        )}
        <div className="breadcrumb">
          <span className="breadcrumb-item">{t('dashboard')}</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-item active">
            {selectedCase ? t('patientInterview') : t('selectCase')}
          </span>
          {sessionId && (
            <>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-item session-id">
                {t('sessionId')}: {sessionId}
              </span>
            </>
          )}
        </div>
      </div>

      <div className="nav-right">
        {!selectedCase && onSubscriptionClick && (
          <button
            className="nav-btn subscription-nav-btn"
            onClick={onSubscriptionClick}
            title={t('viewSubscriptionPlans')}
          >
            <FiCreditCard size={18} />
            <span>{t('subscription')}</span>
          </button>
        )}
        {selectedCase && onReturnToDashboard && (
          <button
            className="nav-btn dashboard-btn"
            onClick={onReturnToDashboard}
            title={t('backToDashboard')}
          >
            <FiGrid size={18} />
            <span>{t('dashboard')}</span>
          </button>
        )}
        {selectedCase && onToggleAnketa && (
          <button
            className="nav-btn anketa-nav-btn"
            onClick={onToggleAnketa}
            title={t('medicalCaseAnketa')}
          >
            <FiFileText size={18} />
            <span>{t('anketa')}</span>
          </button>
        )}
        {selectedCase && onToggleLabReports && (
          <button
            className={`nav-btn lab-reports-btn ${showLabReports ? 'active' : ''}`}
            onClick={onToggleLabReports}
            title={showLabReports ? t('closeLabs') : t('labReports')}
          >
            <FiFileText size={18} />
            <span>{t('labReports')}</span>
          </button>
        )}
        {selectedCase && (
          <button
            className="nav-btn evaluate-btn"
            onClick={onEvaluateClick}
          >
            <FiFileText size={18} />
            <span>{t('evaluate')}</span>
          </button>
        )}
        {user && (
          <div className="user-profile">
            <button
              type="button"
              className="user-info"
              onClick={() => navigate('/profile')}
              title={t('myProfile')}
            >
              <FiUser size={18} />
              <span className="user-name">{user.name || user.email || 'User'}</span>
            </button>
            <button className="nav-btn logout-btn" onClick={handleLogout} title={t('logout')}>
              <FiLogOut size={18} />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TopNav;
